export const HOME_PAGE = "/";
export const WEEK_PAGE = "/week";
export const DAY_PAGE = "/day";
export const ALL_ACTIVITIES_PAGE = "/all-activities";
export const ADD_ACTIVITY_PAGE = "/add-activity";
export const PROFILE_PAGE = "/profile";
export const TRENDS_PAGE = "/trends";
export const LOGIN_CALLBACK_PAGE = "/authentication/login-callback";
export const NOT_FOUND_PAGE = "*";
